import React from 'react'
import { cx } from '@emotion/css'
import styles from './styles'

const Container = ({ className, children }) => <div className={cx(styles.wrapper, className)}>{children}</div>

export default Container
